import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import config from '../../../config';
import {
  requestSources,
  updateSource,
  getSources,
  getSourcesLoaded,
} from '../../../bundles/sources';
import { getActiveSite } from '../../../bundles/sites';
import TfrClassification from './components/TfrClassification';
import SwitchgearCounter from './components/SwitchgearCounter';

const AnalyticsView = () => {
  const dispatch = useDispatch();
  const site = useSelector(getActiveSite);
  const sourcesLoaded = useSelector(getSourcesLoaded);
  const sources = useSelector(getSources);

  useEffect(() => {
    if (site.id && sourcesLoaded !== site.id) {
      dispatch(requestSources({ siteId: site.id, withVariables: false }));
    }
  }, [dispatch, site, sourcesLoaded]);

  const sortedSources = [...sources].toSorted(({ createdAt: a }, { createdAt: b }) => a - b);
  const decSources = sortedSources.filter((source) => source.type === 'dec');
  const analyticsSources = config.onPremise
    ? sortedSources.filter((source) => source.type === 'identiq-ts')
    : decSources;

  const onTfrUpdate = useCallback(
    (sourceId, data) =>
      dispatch(
        updateSource(site.id, sourceId, data, {
          successMessage: 'TFR classification changes successfully saved',
          errorMessage: 'Failed to save TFR classification changes',
        })
      ),
    [site.id, dispatch]
  );

  const onSwitchgearUpdate = useCallback(
    (sourceId, data) =>
      dispatch(
        updateSource(site.id, sourceId, data, {
          successMessage: 'Switchgear counter changes successfully saved',
          errorMessage: 'Failed to save switchgear counter changes',
        })
      ),
    [site.id, dispatch]
  );

  return (
    <>
      {!config.onPremise && (
        <TfrClassification
          site={site}
          sources={decSources}
          onUpdate={onTfrUpdate}
        />
      )}
      <SwitchgearCounter
        site={site}
        sources={analyticsSources}
        onUpdate={onSwitchgearUpdate}
        isOnPremise={config.onPremise}
      />
    </>
  );
};

export default AnalyticsView;
